import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep, toNumber } from 'lodash-es'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import NullData from './nullData'
import rate from '../assets/rate.png'

const Rate = styled.div`
  background: url(${rate}) no-repeat scroll;
  width: 72px;
  height: 24px;
  background-size: 100% 100%;
  ${tw`flex items-center justify-center text-sm`}
`
const ProgressStyled = styled.div`
  position: relative;
  height: 17px;
  .out {
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    background: rgba(52, 204, 255, 0.2);
  }
  .in {
    width: ${(props) => `${props.rate}%`};
    position: absolute;
    left: 0;
    top: 0;
    background-image: linear-gradient(
      180deg,
      rgba(52, 204, 255, 0.89) 0%,
      #2a94e4 100%,
      #405fdc 100%
    );
    height: 100%;
    border-radius: 20px;
  }
`

const ProgressComp = function ({ num, total }) {
  return (
    <div className="flex flex-1 flex-col gap-0.5">
      <div className="flex justify-end" style={{ color: '#72F4C7' }}>
        {total}
      </div>
      <ProgressStyled rate={toNumber((num / total) * 100)}>
        <div className="out" />
        <div className="in" />
      </ProgressStyled>
    </div>
  )
}

const Progress = function ({ data, customDsl }) {
  const { appId } = useParams()
  const [itemData, setItemData] = useState([])

  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        console.log('rr', res)
        setItemData(res)
      })
  }, [customDsl, data])

  return (
    <div className="w-full px-4" style={{ maxHeight: '200px' }}>
      {itemData.length === 0 && <NullData />}
      {itemData.length !== 0 && (
        <div className="flex flex-col mb-4 w-full">
          {itemData.map((item) => {
            return (
              <div
                key={item.name}
                className="flex gap-6 items-end justify-between w-full"
              >
                <div className="flex flex-1 items-end gap-3">
                  <div style={{ width: '20%' }}>{item.name}</div>
                  <ProgressComp num={item.num} total={item.total} />
                </div>
                <Rate>{item.rate}</Rate>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Progress
